import { render } from "./BorrowerId.vue?vue&type=template&id=529123cc"
import script from "./BorrowerId.vue?vue&type=script&lang=js"
export * from "./BorrowerId.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/loans-pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__